import { render, staticRenderFns } from "./AlignLeft.vue?vue&type=template&id=2944c722&"
import script from "./AlignLeft.vue?vue&type=script&lang=js&"
export * from "./AlignLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports